import React, { useState, useEffect } from 'react';
import API from '../../../pages/Api';
import { toast } from 'react-toastify';

import { FaEdit, FaPlus, FaTimes, FaTrash } from 'react-icons/fa';
import TableContainer from '../../common/Tablecontainer'; // 💡 Verified structural path references safely

const QuestionMaster = () => {
    const [questions, setQuestions] = useState([]);
    const [titles, setTitles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    
    // Action modal states references
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedQuestionId, setSelectedQuestionId] = useState(null);

    // Controlled form operational parameter states fields
    const [formData, setFormData] = useState({
        tileid: '',
        question: '',
        marks: '10',
        status: 'A'
    });
    const [list, setList] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [mobilePage, setMobilePage] = useState(1);
    const [loadingCards, setLoadingCards] = useState(false);

    const pageSize = 10;

    const loadQuestionMasterRecords = async (
        page = 1,
        search = searchQuery
    ) => {

        try {

            setLoadingCards(true);

            const res = await API.get(
                "question-master/",
                {
                    params:{
                        page,
                        search
                    }
                }
            );

            if(res.data.results){

                setList(res.data.results);

                setTotalCount(res.data.count);

            }
            else{

                setList(res.data);

                setTotalCount(res.data.length);

            }

        }
        catch(err){

            console.error(err);

            setList([]);

            setTotalCount(0);

        }
        finally{

            setLoadingCards(false);

        }

    };

    const loadDropdownTitleMasters = async () => {
        try {

            const res = await API.get(
                "title-master/"
            );

            if (Array.isArray(res.data)) {
                setTitles(res.data);
            } else if (Array.isArray(res.data.results)) {
                setTitles(res.data.results);
            } else {
                setTitles([]);
            }

        } catch (err) {

            console.error(err);

            setTitles([]);

        }
    };

    useEffect(()=>{

    loadDropdownTitleMasters();

    },[]);

    useEffect(()=>{

    const timer=setTimeout(()=>{

    loadQuestionMasterRecords(

    mobilePage,

    searchQuery

    );

    },400);

    return ()=>clearTimeout(timer);

    },[mobilePage,searchQuery]);

    const openAddModalWindow = (refreshTable) => {
        setFormData({ tileid: '', question: '', marks: '10', status: 'A' });
        setIsEditMode(false);
        setIsModalOpen(true);
        window.activeTableRefresh = refreshTable;
    };

    const openEditModalWindow = (item, refreshTable) => {
        setFormData({
            tileid: item.tileid,
            question: item.question,
            marks: item.marks,
            status: item.status
        });
        setSelectedQuestionId(item.questionid);
        setIsEditMode(true);
        setIsModalOpen(true);
    };

    const handleFormSubmitAction = async (e) => {
        e.preventDefault();
        if (!formData.tileid || !formData.question) {
           toast.warn("Please complete required input parameters rows configurations.");
            return;
        }

        try {
            if (isEditMode) {
                const res = await API.put(`question-master/${selectedQuestionId}/`, formData);
                if (res.data.status === "Success") toast.success("Question item configuration updated smoothly.");
            } else {
                const res = await API.post('question-master/', formData);
                if (res.data.status === "Success") toast.success("New question row synchronized inside database ledger.");
            }
            setIsModalOpen(false);

            await loadQuestionMasterRecords(
                mobilePage,
                searchQuery
            );

            if(window.activeTableRefresh){

            window.activeTableRefresh();

            }
        } catch (err) {
            console.error("Operational crash executing submit payload mapping stack instances:", err);
        }
    };

    const handleRecordDeleteTrigger = async (pk) => {
        if (!window.confirm("Are you completely sure you want to delete this specific database question row record?")) return;
        try {
            const res = await API.delete(`question-master/${pk}/`);
            if (res.data.status === "Success") {
                toast.success("Question removed successfully.");
                await loadQuestionMasterRecords(
                    mobilePage,
                    searchQuery
                );
            }
        } catch (err) {
            console.error("Failure processing delete entity instruction:", err);
        }
    };

    // Client-side filtering configuration checks matching wireframe search parameters
    // const filteredQuestions = questions.filter(item => 
    //     item.question?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //     item.title_name?.toLowerCase().includes(searchQuery.toLowerCase())
    // );

    const gridHeaders = ['Title Name', 'Question', 'Marks', 'Action'];

    return (
        
        <div className="p-6 bg-[#F8FAFC] min-h-screen w-full flex flex-col items-center font-sans">
            <h2 className="text-center text-2xl sm:text-3xl md:text-4xl font-light text-gray-700 mb-8 tracking-tight">
                        Question Master
            </h2>
            
            {/* 💡 FIX: Set optimized page-proportional grid layout constraints (`max-w-6xl`) with uniform paddings */}
            <div className="w-full max-w-6xl mx-auto flex flex-col space-y-4 px-2">
                
                {/* ─── 💡 BLOCK 1: WIREFRAME PAGE HEADING TITLE ─── */}
               
                {/* ─── 💡 BLOCK 2 & 4: SEARCH BAR & SIZES DROPDOWN (Injected dynamically through your shared TableContainer) ─── */}

                {/* ─── 💡 BLOCK 3: SEPARATE ROW CONTAINER FOR ADD BUTTON RIGHT BELOW FILTERS ─── */}
                {/* 💡 FIX: Replaced border-box padding attributes to make button stand out seamlessly without crowding the data headers */}
                <div className="w-full px-2 py-2 flex justify-center md:justify-end">
                    <button 
                        type="button"
                        onClick={() =>
                            openAddModalWindow(
                                window.activeTableRefresh
                            )
                        }
                        className="w-full md:w-auto bg-[#032167] text-white px-5 py-2 rounded text-xs font-semibold tracking-wide flex items-center gap-2 hover:bg-blue-950 transition-all border-none cursor-pointer shadow-sm active:scale-95"
                    >
                        <FaPlus size={10} /> Add New Question
                    </button>
                </div>

                {/* ─── 💡 BLOCK 4: CORE RENDER PRESENTATION DATA TABLE ─── */}
                {/* 💡 FIX: Enclosed table container mappings natively to align perfectly inside the new max-w-6xl grid matrix specs */}
                <div className="hidden md:block">

                <TableContainer
                    columns={gridHeaders}
                    apiUrl="question-master/"
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery} 
                    searchPlaceholder="Search questions globally across all pages..."
                    renderRow={(item, index, srNo, formatCurrency, refreshTable) => (
                        <tr key={item.questionid || index} className="border-b border-gray-200 hover:bg-gray-50 transition-colors h-[40px] text-gray-700 text-xs font-medium bg-white">
                            <td className="p-3 border-r bg-gray-50/50 font-bold text-gray-400 w-[6%] text-center">{srNo}</td>
                            <td className="p-3 border-r text-left pl-5 w-[22%] uppercase font-bold text-[#032167] tracking-wide">{item.title_name || 'N/A'}</td>
                            <td className="p-3 border-r text-left pl-5 font-normal text-gray-600 max-w-lg truncate">{item.question}</td>
                            <td className="p-3 border-r font-bold text-blue-900 w-[10%] text-center">{item.marks}</td>
                            
                            <td className="w-[12%] p-0">
                                <div className="flex items-center justify-center w-full h-[40px]">
                                    <div className="flex-1 flex justify-center items-center h-full border-r border-gray-200">
                                        <button type="button" onClick={() => openEditModalWindow(item, refreshTable)} className="text-[#5c9314] hover:text-green-800 border-none bg-transparent cursor-pointer transition-all flex items-center justify-center w-full h-full" title="Edit Question Attributes">
                                            <FaEdit size={18} />
                                        </button>
                                    </div>
                                    <div className="flex-1 flex justify-center items-center h-full">
                                        <button type="button" onClick={() => handleRecordDeleteTrigger(item.questionid, refreshTable)} className="text-gray-400 hover:text-red-600 border-none bg-transparent cursor-pointer transition-all flex items-center justify-center w-full h-full" title="Delete Row Ledger Entry">
                                            <FaTrash size={16} />
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    )}
                />
                </div>

                <div className="md:hidden mt-4">

                <input
                type="text"
                value={searchQuery}
                placeholder="Search Question..."
                onChange={(e)=>{

                setSearchQuery(e.target.value);

                setMobilePage(1);

                }}
                className="w-full border rounded-lg p-3 text-sm"
                />

                </div>
                <div className="md:hidden space-y-4 mt-4">

            {

            loadingCards

            ?

            <div className="text-center py-10">

            Loading...

            </div>

            :

            list.length===0

            ?

            <div className="text-center py-10">

            No Record Found

            </div>

            :

            list.map((item)=>(

            <div
            key={item.questionid}
            className="bg-white rounded-xl shadow border p-4">

            <div className="space-y-3">

            <div>

            <p className="text-xs text-gray-500">

            Title

            </p>

            <p className="font-bold text-[#032167]">

            {item.title_name}

            </p>

            </div>

            <div>

            <p className="text-xs text-gray-500">

            Question

            </p>

            <p className="text-sm">

            {item.question}

            </p>

            </div>

            <div>

            <p className="text-xs text-gray-500">

            Marks

            </p>

            <p className="font-bold">

            {item.marks}

            </p>

            </div>

            <div className="flex justify-end gap-5 border-t pt-3">

            <button
            onClick={() =>
                openEditModalWindow(
                    item,
                    window.activeTableRefresh
                )
            }
            className="text-green-600">

            <FaEdit/>

            </button>

            <button
            onClick={()=>handleRecordDeleteTrigger(item.questionid)}
            className="text-red-600">

            <FaTrash/>

            </button>

            </div>

            </div>

            </div>

            ))

            }

            </div>
            <div className="md:hidden flex justify-between items-center mt-5">

            <button
            disabled={mobilePage===1}
            onClick={()=>setMobilePage(p=>p-1)}
            className="px-4 py-2 border rounded disabled:opacity-40">

            Previous

            </button>

            <span>

            Page {mobilePage} of {Math.max(1,Math.ceil(totalCount/pageSize))}

            </span>

            <button
            disabled={
            mobilePage>=Math.max(
            1,
            Math.ceil(totalCount/pageSize)
            )
            }
            onClick={()=>setMobilePage(p=>p+1)}
            className="px-4 py-2 border rounded disabled:opacity-40">

            Next

            </button>

            </div>

            </div>

            {/* --- Add / Edit Form Modal Panel Overlay Framework --- */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-black/50 overflow-y-auto z-[4000]">
                    <div className="min-h-full flex items-center justify-center p-3 md:p-6"> 
                    <div className="bg-white w-full max-w-[95vw] sm:max-w-xl rounded-lg shadow-2xl overflow-hidden relative border border-gray-300">
                        <div className="flex items-center justify-between p-3.5 border-b bg-gray-50">
                            <h3 className="text-sm font-bold text-[#02205c] uppercase tracking-wider">
                                {isEditMode ? 'Modify Question Form Definition' : 'Append Fresh Master Question Entry'}
                            </h3>
                            <button 
                                type="button" 
                                onClick={() => setIsModalOpen(false)}
                                className="text-gray-500 hover:text-black border-none bg-transparent text-xl cursor-pointer font-bold"
                            >
                                <FaTimes size={16} />
                            </button>
                        </div>

                        <form onSubmit={handleFormSubmitAction} className="p-3 sm:p-5 md:p-6 space-y-4 text-xs font-semibold uppercase text-gray-700">
                            <div className="flex flex-col space-y-1.5">
                                <label>Select Category Master Title <span className="text-red-500">*</span></label>
                                <select value={formData.tileid} onChange={(e) => setFormData({...formData, tileid: e.target.value})} className="p-2.5 border border-gray-300 rounded outline-none bg-gray-50 font-bold text-gray-800 normal-case" required>
                                    <option value="">-- Choose Target Title Header --</option>
                                    {titles?.map((title) => (
                                        <option
                                            key={title.tileid}
                                            value={title.tileid}
                                        >
                                            {title.titledesc}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="flex flex-col space-y-1.5">
                                <label>Question Content Description Text <span className="text-red-500">*</span></label>
                                <textarea rows={4} value={formData.question} onChange={(e) => setFormData({...formData, question: e.target.value})} placeholder="Type question content details here..." className="p-2.5 border border-gray-300 rounded outline-none bg-gray-50 font-medium normal-case text-gray-700 resize-none" required />
                            </div>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div className="flex flex-col space-y-1.5">
                                    <label>Weightage Marks</label>
                                    <input type="number" value={formData.marks} onChange={(e) => setFormData({...formData, marks: e.target.value})} className="p-2.5 border border-gray-300 rounded outline-none bg-gray-50 font-bold text-blue-900" />
                                </div>
                                <div className="flex flex-col space-y-1.5">
                                    <label>Active Status Mode</label>
                                    <select value={formData.status} onChange={(e) => setFormData({...formData, status: e.target.value})} className="p-2.5 border border-gray-300 rounded outline-none bg-gray-50 font-bold">
                                        <option value="A">Active Permission State</option>
                                        <option value="I">Inactive Locked State</option>
                                    </select>
                                </div>
                            </div>
                            <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 pt-4 border-t mt-6">
                                <button type="button" onClick={() => setIsModalOpen(false)} className="w-full sm:w-auto px-5 py-2 bg-gray-100 text-gray-700 rounded font-bold uppercase tracking-wider border hover:bg-gray-200 cursor-pointer">Cancel</button>
                                <button type="submit" className=" w-full sm:w-auto px-6 py-2 bg-[#032167] text-white rounded font-bold uppercase tracking-wider hover:bg-blue-950 transition-all cursor-pointer border-none shadow-md">Save Question</button>
                            </div>
                        </form>
                    </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default QuestionMaster;